/* Cart drawer + menu drawer behaviour (open, close, live cart updates) */
(function () {
  'use strict';
  if (window.__hnDrawers) return;
  window.__hnDrawers = true;
  var d = document, root = d.documentElement, DUR = 760;
  var cartTimer = null, menuTimer = null, queue = Promise.resolve(), pending = 0, SID = null;

  function cartEl() { return d.getElementById('HnCartDrawer'); }
  function menuEl() { return d.getElementById('HnMenuDrawer'); }
  function onCartPage() { return /\/cart\/?$/.test(window.location.pathname); }
  function sectionId() {
    if (SID) return SID;
    var el = cartEl(), w = el && el.closest('.shopify-section');
    SID = w ? w.id.replace('shopify-section-', '') : 'hn-cart-drawer';
    return SID;
  }
  function anyOpen() { return !!d.querySelector('#HnCartDrawer.is-open, #HnMenuDrawer.is-open'); }
  function lock() {
    if (root.classList.contains('hn-lock')) return;
    var sbw = window.innerWidth - root.clientWidth;
    if (sbw > 0) root.style.paddingRight = sbw + 'px';
    root.classList.add('hn-lock');
  }
  function unlock() {
    if (anyOpen()) return;
    root.classList.remove('hn-lock');
    root.style.paddingRight = '';
  }
  function focusEl(el) { if (!el) return; try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); } }

  /* ---------- badges ---------- */
  function setBadges(count) {
    var icon = d.getElementById('cart-icon-bubble');
    if (icon) {
      var b = icon.querySelector('.cart-count-bubble');
      if (count > 0) {
        if (!b) {
          b = d.createElement('div');
          b.className = 'cart-count-bubble';
          b.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden"></span>';
          icon.appendChild(b);
        }
        var spans = b.querySelectorAll('span');
        if (spans[0]) spans[0].textContent = count;
        if (spans[1]) spans[1].textContent = count + ' item' + (count === 1 ? '' : 's');
      } else if (b) { b.remove(); }
    }
    d.querySelectorAll('[data-hn-menu-n]').forEach(function (n) { n.textContent = count; n.hidden = !(count > 0); });
    var n2 = d.querySelector('[data-hn-cd-n]');
    if (n2) { n2.textContent = count; n2.hidden = !(count > 0); }
  }
  function showErr(msg) {
    var e = d.querySelector('[data-hn-cd-err]');
    if (!e) return;
    if (msg) { e.textContent = msg; e.hidden = false; } else { e.hidden = true; }
  }
  function busy(on) { var b = d.querySelector('[data-hn-cd-inner]'); if (b) b.classList.toggle('is-busy', on); }
  function stagger() {
    var c = d.querySelector('[data-hn-cd-inner]');
    if (c) c.querySelectorAll('.hn-cd__item').forEach(function (li, i) { li.style.setProperty('--i', i); });
  }

  /* ---------- reading the cart drawer from the server ---------- */
  function keyOf(li) {
    var t = li.querySelector('.hn-cd__t'), v = li.querySelectorAll('.hn-cd__vv');
    return (t ? t.textContent : '') + '|' + Array.prototype.map.call(v, function (x) { return x.textContent; }).join('|');
  }
  /* Same lines as before: only change numbers in place, so nothing jumps. */
  function patch(cur, next) {
    var cl = cur.querySelectorAll('.hn-cd__item'), nl = next.querySelectorAll('.hn-cd__item'), i;
    if (!cl.length || cl.length !== nl.length) return false;
    for (i = 0; i < cl.length; i++) if (keyOf(cl[i]) !== keyOf(nl[i])) return false;
    for (i = 0; i < cl.length; i++) {
      var a = cl[i], b = nl[i];
      a.setAttribute('data-hn-cd-line', b.getAttribute('data-hn-cd-line'));
      var ai = a.querySelector('[data-hn-cd-q]'), bi = b.querySelector('[data-hn-cd-q]');
      if (ai && bi && ai !== d.activeElement) ai.value = bi.value;
      ['.hn-cd__u', '.hn-cd__tot'].forEach(function (sel) {
        var x = a.querySelector(sel), y = b.querySelector(sel);
        if (x && y && x.innerHTML !== y.innerHTML) x.innerHTML = y.innerHTML;
      });
      a.querySelectorAll('.hn-cd__d').forEach(function (n) { n.remove(); });
      var row = a.querySelector('.hn-cd__row');
      b.querySelectorAll('.hn-cd__d').forEach(function (n) { row.parentNode.insertBefore(d.importNode(n, true), row); });
      var ar = a.querySelector('[data-hn-cd-rm]'), br = b.querySelector('[data-hn-cd-rm]');
      if (ar && br) ar.setAttribute('href', br.getAttribute('href'));
    }
    var af = cur.querySelector('.hn-cd__foot'), bf = next.querySelector('.hn-cd__foot');
    if (af && bf && af.innerHTML !== bf.innerHTML) af.innerHTML = bf.innerHTML;
    return true;
  }
  function fetchNext() {
    var id = sectionId();
    return fetch('/?sections=' + encodeURIComponent(id) + '&_=' + Date.now(), { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var doc = new DOMParser().parseFromString(j[id] || '', 'text/html');
        var next = doc.querySelector('[data-hn-cd-inner]');
        if (!next) throw new Error('no drawer');
        return next;
      });
  }
  function apply(next) {
    var cur = d.querySelector('[data-hn-cd-inner]');
    if (!cur) throw new Error('no drawer');
    if (!patch(cur, next)) {
      var list = cur.querySelector('.hn-cd__list'), top = list ? list.scrollTop : 0;
      cur.innerHTML = next.innerHTML;
      stagger();
      var nl = cur.querySelector('.hn-cd__list');
      if (nl) nl.scrollTop = top;
    }
    cur.setAttribute('data-count', next.getAttribute('data-count') || '0');
    setBadges(parseInt(next.getAttribute('data-count'), 10) || 0);
  }
  function refresh() { return fetchNext().then(apply); }

  /* ---------- open and close the cart drawer ---------- */
  function openCart() {
    var drawer = cartEl();
    if (!drawer) return;
    if (cartTimer) { clearTimeout(cartTimer); cartTimer = null; }
    if (!drawer.classList.contains('is-open')) {
      lock();
      stagger();
      drawer.__op = d.activeElement;
      drawer.hidden = false;
      void drawer.offsetWidth;
      drawer.classList.add('is-open');
    }
    focusEl(drawer.querySelector('.hn-cd__x'));
  }
  function closeCart() {
    var drawer = cartEl();
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    cartTimer = setTimeout(function () {
      drawer.hidden = true;
      cartTimer = null;
      unlock();
      focusEl(drawer.__op);
    }, DUR);
  }

  /* ---------- open and close the menu drawer ---------- */
  function openMenu() {
    var drawer = menuEl();
    if (!drawer) return;
    if (menuTimer) { clearTimeout(menuTimer); menuTimer = null; }
    if (!drawer.classList.contains('is-open')) {
      lock();
      drawer.querySelectorAll('.hn-md__list > li').forEach(function (li, i) { li.style.setProperty('--i', i); });
      drawer.__op = d.activeElement;
      drawer.hidden = false;
      void drawer.offsetWidth;
      drawer.classList.add('is-open');
    }
    focusEl(drawer.querySelector('.hn-md__x'));
  }
  function closeMenu() {
    var drawer = menuEl();
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    menuTimer = setTimeout(function () {
      drawer.hidden = true;
      menuTimer = null;
      unlock();
      focusEl(drawer.__op);
    }, DUR);
  }

  /* ---------- changing quantities ---------- */
  function collapse(li) {
    li.style.height = li.offsetHeight + 'px';
    void li.offsetHeight;
    li.classList.add('is-collapsing');
    li.style.height = '0px';
  }
  function uncollapse(li) { li.classList.remove('is-collapsing'); li.style.height = ''; }
  function change(li, qty) {
    var rm = li.querySelector('[data-hn-cd-rm]'), key = null;
    try { key = new URL(rm.getAttribute('href'), window.location.origin).searchParams.get('id'); } catch (e) {}
    var line = parseInt(li.getAttribute('data-hn-cd-line'), 10), removing = qty === 0;
    pending++;
    busy(true);
    if (removing) collapse(li);
    queue = queue.then(function () {
      var err = '';
      var wait = new Promise(function (res) { setTimeout(res, removing ? 460 : 0); });
      var body = key ? { id: key, quantity: qty } : { line: line, quantity: qty };
      var req = fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) err = j.description || j.message || 'Could not update the cart.'; }); })
        .catch(function () { err = 'Could not update the cart. Please try again.'; });
      return Promise.all([req, wait]).then(fetchNext).then(function (next) {
        if (removing) { if (err) uncollapse(li); else if (li.parentNode) li.parentNode.removeChild(li); }
        apply(next);
        showErr(err);
      }).catch(function () { window.location.reload(); });
    }).then(function () { pending--; if (pending <= 0) { pending = 0; busy(false); } });
    return queue;
  }

  /* ---------- adding to the cart ---------- */
  function addToCart(form, fd) {
    if (form.__hnBusy) return;
    form.__hnBusy = true;
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.classList.add('loading');
    var err = '';
    /* open straight away; the spinner covers the list until the new cart is in */
    var qm = form.closest && form.closest('quick-add-modal');
    if (qm && qm.hide) { try { qm.hide(true); } catch (e) {} }
    closeMenu();
    showErr('');
    busy(true);
    openCart();
    fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) err = j.description || j.message || 'Could not add this item to the cart.'; }); })
      .catch(function () { err = 'Could not add this item to the cart. Please try again.'; })
      .then(refresh)
      .then(function () { showErr(err); })
      .catch(function () { form.submit(); })
      .then(function () { busy(false); form.__hnBusy = false; if (btn) btn.classList.remove('loading'); });
  }

  /* ---------- events ---------- */
  d.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches || !f.matches('form[action*="/cart/add"]') || f.hasAttribute('data-hn-skip')) return;
    if (!cartEl() || onCartPage()) return;
    var sub = e.submitter;
    if (sub && (sub.name === 'checkout' || (sub.closest && sub.closest('.shopify-payment-button')))) return;
    var fd = new FormData(f);
    if (!fd.get('id')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    addToCart(f, fd);
  }, true);

  d.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;
    var menuBtn = t.closest('header-drawer summary, .header__icon--menu');
    if (menuBtn && menuEl()) { e.preventDefault(); e.stopPropagation(); openMenu(); return; }
    var opener = t.closest('#cart-icon-bubble, a.header__icon--cart, [data-hn-cd-open]');
    if (opener && cartEl() && !onCartPage()) {
      e.preventDefault();
      e.stopPropagation();
      closeMenu();
      showErr('');
      openCart();
      refresh().catch(function () {});
      return;
    }
    var link = t.closest('[data-hn-cd-link]');
    if (link) {
      try { var u = new URL(link.href, window.location.href); if (u.pathname === window.location.pathname) { e.preventDefault(); closeCart(); } } catch (err) {}
      return;
    }
    if (t.closest('[data-hn-cd-close]')) { closeCart(); return; }
    if (t.closest('[data-hn-menu-close]')) { closeMenu(); return; }
    var mlink = t.closest('.hn-md__list a');
    if (mlink) {
      try { var mu = new URL(mlink.href, window.location.href); if (mu.pathname === window.location.pathname && !mu.hash) { e.preventDefault(); closeMenu(); } } catch (err2) {}
      return;
    }
    var rm = t.closest('[data-hn-cd-rm]'), qm2 = t.closest('[data-hn-cd-qm]'), qp = t.closest('[data-hn-cd-qp]');
    if (rm || qm2 || qp) {
      var li = (rm || qm2 || qp).closest('[data-hn-cd-line]');
      if (!li || li.classList.contains('is-collapsing')) return;
      e.preventDefault();
      var input = li.querySelector('[data-hn-cd-q]');
      var cur = parseInt(input.value, 10) || 0;
      var qty = rm ? 0 : Math.max(0, Math.min(99, cur + (qp ? 1 : -1)));
      input.value = qty;
      change(li, qty);
    }
  }, true);

  d.addEventListener('change', function (e) {
    var input = e.target.closest ? e.target.closest('[data-hn-cd-q]') : null;
    if (!input) return;
    var li = input.closest('[data-hn-cd-line]');
    var q = Math.max(0, Math.min(99, parseInt(input.value, 10) || 0));
    input.value = q;
    change(li, q);
  });

  d.addEventListener('keydown', function (e) {
    var cart = cartEl(), menu = menuEl();
    var cartOpen = cart && cart.classList.contains('is-open'), menuOpen = menu && menu.classList.contains('is-open');
    if (!cartOpen && !menuOpen) return;
    if (e.key === 'Escape') { if (cartOpen) closeCart(); if (menuOpen) closeMenu(); return; }
    if (e.key === 'Enter' && e.target.closest && e.target.closest('[data-hn-cd-q]')) { e.preventDefault(); e.target.blur(); return; }
    if (e.key === 'Tab') {
      var drawer = cartOpen ? cart : menu;
      var nodes = drawer.querySelectorAll('a[href],button:not([disabled]),input:not([disabled])');
      var vis = Array.prototype.filter.call(nodes, function (n) { return n.offsetParent !== null; });
      if (!vis.length) return;
      var first = vis[0], last = vis[vis.length - 1];
      if (e.shiftKey && d.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && d.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* The page scrolls with the smooth-scroll library: pause it while a drawer is open. */
  new MutationObserver(function () {
    var l = window.lenisInstance;
    if (!l) return;
    if (root.classList.contains('hn-lock')) l.stop(); else l.start();
  }).observe(root, { attributes: true, attributeFilter: ['class'] });

  window.hnCart = { open: openCart, close: closeCart, refresh: refresh, busy: busy, openMenu: openMenu, closeMenu: closeMenu };
})();